module.exports = __webpack_public_path__ + "img/E08E.df9f2bf1.svg";